import {
  Component,
  OnInit,
  Inject,
  LOCALE_ID,
  AfterViewInit,
  PLATFORM_ID
} from "@angular/core";
import { FacadeService } from "../../service/facade.service";
import { ActivatedRoute } from "@angular/router";
import { DataLayerService } from "../../service/datalayer/datalayer.service";
import { SEO } from "../../models/seo/seoInterface";
import { seoManagement } from "../../../app/models/seo/seoClass";
import { LinkService } from "../../../app/service/link.service";
import { Title, Meta } from "@angular/platform-browser";
import { isPlatformBrowser } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-product",
  templateUrl: "./product.component.html",
  styleUrls: ["./product.component.scss"]
})
export class ProductComponent extends seoManagement
  implements OnInit, SEO, AfterViewInit {
  productId: number;
  jsonLD;
  product;
  afterLoad: Boolean = false;
  title: string;
  description: string;
  image: any;
  url: any;
  constructor(
    private translate: TranslateService,
    private _facadeService: FacadeService,
    private _route: ActivatedRoute,
    private dl: DataLayerService,
    @Inject(LOCALE_ID) public locale,
    @Inject(PLATFORM_ID) private platfromId,
    public link: LinkService,
    public titleService: Title,
    public metaService: Meta
  ) {
    super(
      titleService,
      metaService,
      isPlatformBrowser(platfromId),
      locale,
      link
    );
    this.currentLangId = locale;
    this.translate.setDefaultLang(this.currentLangId);
    this.translate.use(this.currentLangId);
  }

  ngOnInit() {
    this.getProductId();
  }

  ngAfterViewInit() {
    this.afterLoad = true;
  }

  getProductId() {
    this._route.paramMap.subscribe(params => {
      this.productId = JSON.parse(params.get("id"));
      this.getProductProfile();
      this.dl.setDataLayer({
        event: "viewed product",
        content_id: this.productId
      });
    });
  }

  getProductProfile() {
    this._facadeService.Product.ProductProfile({
      product_id: this.productId
    }).subscribe(res => {
      this.product = res.data;
      this.setSeoTagsProperties();
      this.setProductSchema();
    });
  }

  setSeoTagsProperties() {
    const currentUrlLang = this.currentLangId === "en" ? "" : "ar/";
    if (this.currentLangId === "ar") {
      this.title =
        "نيو فرنتشر للاثاث المكتبي ال" + this.product.name + "المناسب لمكتبك";
      this.description = `نيو فرنتشر بتوفرلك جميع الأنواع والمقأسات المختلفة  ${this.product.name} بأفضل جودة وأرخص الأسعار`;
    } else {
      this.title =
        "New furniture Egypt | the suitable" +
        this.product.name +
        " for your office";
      this.description =
        "New furniture provides for you all the different types and sizes of " +
        this.product.name +
        " with the best quality and least prices.";
    }
    this.image = this.product.image;
    this.url =
      "https://www.newfurniture-eg.com/" +
      currentUrlLang +
      "product/" +
      this.productId;
    this.link.addTag({
      rel: "",
      href: `https://www.m.newfurniture-eg.com/${currentUrlLang}product/${this.productId}`
    });

    this.setSeoTags(this.title, this.description, this.image, this.url);
  }

  setProductSchema() {
    const currentLang = this.currentLangId === "en" ? "" : "ar/";
    const url = `https://www.newfurniture-eg.com/${currentLang}product/${this.productId}`;
    this.jsonLD = {
      "@context": "https://schema.org",
      "@type": "Product",
      productID: this.productId,
      name: this.product.name,
      url,
      image: this.product.image,
      brand: "New Furniture",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: 5,
        reviewCount: 11
      }
    };
  }

  /**
   * choose image from gallery
   * @param image image path
   * @param index index of image in gallery
   */
  chooseImage(image, index) {
    // add product image to galley
    this.product.gallery.push({ image: this.product.image });
    // set choosed image to product image
    this.product.image = image;
    // remove choosed image from gallery
    this.product.gallery.splice(index, 1);
  }
}
